export const difficulties = {
  easy: [700, 1100],
  normal: [1100, 1600],
  hard: [1600, 2100],
  expert: [2100, 3000],
  mixed: [800, 2400],
  custom: [700, 2400],
} as const;
export type Difficulty = keyof typeof difficulties;
export const themes = [
  'fork',
  'pin',
  'skewer',
  'discoveredAttack',
  'doubleCheck',
  'sacrifice',
  'deflection',
  'attraction',
  'hangingPiece',
  'trappedPiece',
  'defensiveMove',
  'quietMove',
  'intermezzo',
  'backRankMate',
  'mateIn1',
  'mateIn2',
  'mateIn3',
  'promotion',
  'underPromotion',
  'endgame',
  'advantage',
  'crushing',
] as const;
export const themeLabel = (t: string) =>
  t
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (c) => c.toUpperCase())
    .replace(/In([123])/, 'in $1');
export function randomKey(id: string) {
  let h = 2166136261;
  for (const c of id) h = Math.imul(h ^ c.charCodeAt(0), 16777619);
  return h & 0x7fffffff;
}
export function qualityTier(popularity: number, plays: number, deviation: number) {
  return popularity >= 85 && plays >= 50 && deviation <= 100
    ? 1
    : popularity >= 70 && plays >= 20 && deviation <= 130
      ? 2
      : 3;
}
